let browsers = [
	{id: 'chrome', name: 'Chrome', version: 87, url: 'https://www.google.com/chrome/'},
	{id: 'firefox', name: 'Firefox', version: 85, url: 'https://www.mozilla.org/da/firefox/'},
	{id: 'safari', name: 'Safari', version: 14, url: 'https://support.apple.com/downloads/safari'},
	{id: 'opera', name: 'Opera', version: 72, url: 'http://www.opera.com/da/download'},
	{id: 'edge-chromium', name: 'Edge Chromium', version: 90, url: 'https://microsoft-edge.en.softonic.com/'}
];

export default browsers;